<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid
      .column.is-widescreen-5.is-desktop-6
        .u-mb-mi
          AppImg(:srcset="[{ srcset: '{CDN_URL}/ventures/creavs@2x.webp 2x, {CDN_URL}/ventures/creavs.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/creavs@2x.png 2x, {CDN_URL}/ventures/creavs.png 1x', type: 'image/png' }]" ratio="3:2")
      .column.is-widescreen-5.is-desktop-6
        .content.u-mb-xs
          div(v-html="$t('content')")
        AppLink(to="https://www.behance.net/gallery/74357697/Creavs-Branding-UIUX-Design" :title="$t('cta')" class="button-link  " v-html="$t('cta')")


  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Creavs",
    "pageDesc":"Creavs is an online curation for strategists, developers, designers and techies. It collects the latest from trusted resources and sends custom newsletters.",
    "mantra":"Creavs curation |platform.",
    "content":"<p>The field of creative technology is rapidly changing. Everyday there are new inventions and methodologies that we need to adapt with. As a team, we had the problem of keeping up with the latest news and passing it to each other. Getting the latest in every field of expertise could be overwhelming sometimes. With lots of articles and newsletters from different sources, your inbox could get messy just like ours. </p><p>In an effort of centralizing the communication and ensuring an easy transfer of information, we came up with Creavs. Creavs is a curation for designers, developers, strategists, and techies. It gathers books, guides, articles, videos and infographics from different resources then consolidates it all into a newsletter. And based on your preferences, you can choose to receive updates on a daily, weekly or monthly. </p><p>The platform aims to keep professionals updated in their careers by enhancing their thinking and abilities through materials that is always updated and collected from the latest blog posts and trends. </p><p>The true value behind Creavs value comes from how it saves time and gathers up the best of the best in a mini digest so subscribers can stay updated easily. The project will be launched by late 2019 and you can check the brand identity and website design.</p>",
    "cta":"Brand identity and UI/UX"
  },
  "ar": {
    "pageTitle":"كريفز",
    "pageDesc":"كريفز منصة للمصممين والمبرمجين والاستراتيجيين، تجمع أحدث الأخبار من المصادر الموثوق بها ليتم إرسالها في رسائل مخصصة.",
    "mantra":"كريفز منصة |للأخبار التقنية. ",
    "content":"<p>مجال التكنولوجيا الإبداعية يتغير بسرعة. كل يوم هناك اختراعات ومنهجيات نحتاج إلى معرفتها والتكيف معها. كفريق، واجهتنا مشكلة مواكبة آخر الأخبار ونقلها إلى بعضنا البعض.الحصول على أحدث الأخبار في كل مجال من أصحاب الخبرة والرواد قد يكون صعبًا بعض الشيء، مع وجود الكثير من المقالات والنشرات الإخبارية من مصادر مختلفة، سوف تجعل البريد الإلكتروني الخاص بك مزدحمًا وبه الكثير من الفوضى مثلنا تمامًا. </p><p>في محاولة منا لمركزية الاتصالات فيما بينا وسهولة نقل المعلومات أنشأنا كريفز. كريفز هي تجميع للأخبار من أجل المصممين والمبرمجين والاستراتيجيين، حيث أنها تجمع الكتب والأدلة والمقالات والكتب ومقاطع الفيديو والرسوم البيانية من مصادر مختلفة ودمجها معًا في رسالة إخبارية واحدة. وبناءً على التفضيلات التي اختارتها يمكنك تلقي هذه التحديثات على أساس يومي أو اسبوعي. </p><p>تهدف المنصة إلى إبقاء المهنيين على إطلاع على أحدث الأخبار في مجالاتهم، من خلال تعزيز تفكيرهم وقدراتهم من خلال المواد التي يتم تحديثها دائمًا وتجميعها ومن أحدث المقالات والترندات. </p><p>تأتي القيمة التي نمنحها للعملاء عن طريق توفير كريفز وقتهم، من خلال جمع الأفضل من الأفضل بالنسبة لهم في خلاصة صغيرة ليظلوا على علم بأحدث الأخبار طوال الوقت.</p><p>سوف يتم إطلاق المشروع في أواخر 2019. ويمكنك التحقق من هوية العلامة التجارية وتصميم الموقع على بيهانس.</p>",
    "cta":"تصميم الهوية التجارية وتصميم تجربة المستخدم وواجهة المستخدم"
  }
}
</i18n>
